import { observer } from 'mobx-react-lite'
import { type FC, type MouseEvent } from 'react'
import { Button } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { AccordionSection } from 'widgets/CallPopUp/ui/components/AccordionSection/AccordionSection'
import { ContactsList } from 'widgets/CallPopUp/ui/components/ContactsList/ContactsList'
import { useCallPopUpGlobalContext } from 'widgets/CallPopUp/context/callPopUpGlobalContext'

type ICallQueueSectionProps = {
  type?: 'default' | 'queue'
}

export const CallQueueSection: FC<ICallQueueSectionProps> = observer(({ type }) => {
  const { callStore } = useEntitiesContext()
  const callPopUpGlobalStore = useCallPopUpGlobalContext()
  const store = useCallPopUpDefaultContext()
  const { callPopUpQueueStore, callPopUpPowerDialerStoreV2 } = store
  const { count, items, hasItem } = callPopUpQueueStore
  const { isPowerDialerRunning } = callPopUpPowerDialerStoreV2

  if (!count) return null

  const disabledButton = Boolean(
    callStore.isBusy || callPopUpGlobalStore.hasActiveV1Call || !hasItem
  )

  const handleCall = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    callPopUpQueueStore.handleCallQueue()
    callPopUpGlobalStore.handleSignalTakeCall(true)
  }
  const showButton = type === 'queue' || isPowerDialerRunning || hasItem

  return (
    <AccordionSection
      count={count}
      title={'Call queue'}
      renderButton={
        showButton && (
          <Button
            text={'Take call'}
            contained={'primary'}
            intent={'positive'}
            size={'small'}
            disabled={disabledButton}
            onClick={handleCall}
          />
        )
      }
    >
      <ContactsList items={items} />
    </AccordionSection>
  )
})
